function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}


// Can be used for delayed popups in the future
$(document).ready(function () {
  const $delayed_popup = $('#delayed-popup');
  if ($delayed_popup.length) {
    if (!getCookie('popup-background')) {
      setCookie('popup-background', 1, 5);
      // $('#popup-background').delay(4800).fadeIn(400);
      $delayed_popup.delay(5000).fadeIn(400);
      $('#btn-close').click(function (e) {
        hideDialog();
        e.preventDefault();
      });
    }
  }

  const $delayed_newsletter = $('#delayed-newsletter-modal');
  let searchParams = new URLSearchParams(window.location.search);
  const form_trigger = searchParams.get('trigger-form');
  if ($delayed_newsletter.length && !form_trigger) {
    if (!getCookie('newsletter-modal')) {
      setTimeout(() => {
        setCookie('newsletter-modal', 1, 365);
        // $('#popup-background').delay(4800).fadeIn(400);
        $delayed_newsletter.trigger('click');
      }, 3000);
    }
  }
});

function hideDialog() {
  // $('#popup-background').fadeOut(400);
  $('#delayed-popup').fadeOut(300);
}




// WEBPACK FOOTER //
// ./static/js/modules/delayed_popup.js